export default {
  PLAY: 'VIDEO_PLAY',
  PAUSE: 'VIDEO_PAUSE',
};



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayerStates.js